import { ACCOUNTSAVED } from 'utils/reducers';

const initialState = {
    show: false,
};

const showAccountSavedReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACCOUNTSAVED.display:
            return { ...state, show: true };
        case ACCOUNTSAVED.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showAccountSavedReducer;
